@switch (data.component) {
  @case ('about') {
    <app-modal-content-about />
  }
  @case ('need-help') {
    <app-modal-content-need-help
      [messageSeed]="data.data?.messageSeed"
      [emailAddressOverride]="data.data?.emailAddressOverride"
      [subjectOverride]="data.data?.subjectOverride"
      (closed)="handleClose($event)"
    />
  }
  @case ('about-timesheet') {
    <app-modal-content-about-timesheet />
  }
  @case ('delete-timesheet') {
    <app-modal-content-delete-timesheet [date]="data.data.date" (closed)="handleClose($event)" />
  }
  @case ('confirm-abandon') {
    <app-modal-content-confirm-abandon (closed)="handleClose($event)" />
  }
  @case ('simple-display') {
    <app-modal-content-simple-display
      [titleText]="data.data.titleText"
      [bodyText]="data.data.bodyText"
      (closed)="handleClose($event)"
    />
  }
}
<!-- Put the close X button last so that it isn't auto-focused when the modal is opened -->
<button mat-icon-button mat-dialog-close aria-label="Close" (click)="handleClose()"><mat-icon>close</mat-icon></button>
